import Error from '../views/Error.vue';
import Home from '../views/Home.vue';
import JobsDetails from '../views/Job/JobDetails.vue';
import Jobs from '../views/Job/Jobs.vue';
import JobsList from '../views/Job/JobsList.vue';
import Login from '../views/Login.vue';
import LoginCompany from '../views/LoginCompany.vue';
import NewPassword from '../views/NewPassword.vue';
import ResetPassword from '../views/ResetPassword.vue';
import routeCompany from './company';
import routeAdmin from './admin';

const routes = [
  {
    path: '/entrar',
    name: 'Login',
    component: Login,
    meta: {
      allowAnonymous: true,
      hideChrome: true,
    },
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('../views/404.vue'),
    meta: {
      allowAnonymous: true,
      hideChrome: true,
    },
  },
  {
    path: '/empresa-entrar',
    name: 'LoginCompany',
    component: LoginCompany,
    meta: {
      allowAnonymous: true,
      hideChrome: true,
    },
  },
  {
    path: '/nova-conta',
    name: 'SignUp',
    component: () => import('../views/SignUp.vue'),
    meta: {
      allowAnonymous: true,
      hideChrome: true,
    },
  },
  {
    path: '/redefinir-senha',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      allowAnonymous: true,
      hideChrome: true,
    },
  },
  {
    path: '/nova-senha',
    name: 'NewPassword',
    component: NewPassword,
    meta: {
      allowAnonymous: true,
      hideChrome: true,
    },
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      allowAnonymous: true,
      hideChrome: true,
    },
  },
  {
    path: '/',
    name: 'Error',
    component: Error,
    meta: {
      allowAnonymous: true,
    },
  },
  {
    path: '/como-funciona',
    name: 'HowItsWorks',
    component: () => import('../views/HowItsWorks.vue'),
    meta: {
      allowAnonymous: true,
      hideChrome: true,
    },
  }, {
    path: '/sobre-a-indicoo',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      allowAnonymous: true,
      hideChrome: true,
    },
  },
  {
    path: '/contato',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: {
      allowAnonymous: true,
      hideChrome: true,
    },
  },
  {
    path: '/usuario',
    name: 'User',
    component: () => import('../views/User/UserMaster.vue'),
    meta: {
      disableScrollToTop: true,
      hideChrome: true,
    },
    children: [
      {
        path: '',
        redirect: { name: 'UserDashboard' },
      },
      {
        path: 'dashboard',
        name: 'UserDashboard',
        component: () => import('../views/User/UserDashboard.vue'),
      },
      {
        path: 'indicacoes',
        name: 'UserIndications',
        component: () => import('../views/User/UserIndications.vue'),
      },
      {
        path: 'perfil',
        name: 'UserProfile',
        component: () => import('../views/User/UserProfile.vue'),
      },
      {
        path: 'resumo',
        name: 'UserResume',
        component: () => import('../views/User/UserResume.vue'),
      },
      {
        path: 'recomendacoes',
        name: 'UserRecommendations',
        component: () => import('../views/User/UserRecommendations.vue'),
      },
      {
        path: 'extrato',
        name: 'UserExtract',
        component: () => import('../views/User/Extract/UserExtract.vue'),
      },
      {
        path: '/calculadora-comissao',
        name: 'CommissionCalculator',
        component: () => import('../views/User/CommissionCalculator.vue'),
        meta: {
          allowAnonymous: true,
        },
      },
    ],
  },
  routeCompany,
  routeAdmin,
  {
    path: '/vagas',
    name: 'Jobs',
    component: Jobs,
    children: [
      {
        path: '',
        name: 'JobsList',
        component: JobsList,
        meta: {
          allowAnonymous: true,
          hideChrome: true,
        },
      },
      {
        path: ':jobId/detalhes',
        name: 'JobDetails',
        meta: {
          allowAnonymous: true,
          hideChrome: true,
        },
        component: JobsDetails,
      },
      {
        path: ':jobId/indicar',
        name: 'JobIndication',
        meta: {
          allowAnonymous: false,
          hideChrome: true,
        },
        component: JobsDetails,
      },
    ],
  },
  {
    path: '/indicar-candidato',
    name: 'IndicationPost',
    component: () => import('../views/Indications/IndicationPost.vue'),
  },
];

export default routes;
